import discardNullableValues from './discardNullableValues';

export default discardNullableValues;
